export default "__VITE_ASSET__$hKSu6am__"